export default __webpack_public_path__ + "static/media/moinitor.84bf11e7.png";